export default "/images/sem-resultado-b.png?e7e125d383fd5cf3d750d9e67a498d0d";